import $ from 'jquery';

$(document).ready(function() {
    if ($('.addthis-usedefaultconfig').length > 0)
    {
        window.addthis_share =
        {
            email_template: "GeneralTemplate",
            email_vars:
            {
                domain: window.location.origin,
                ImageUrl: $('meta[property="og:image"]').attr("content"),
                CardTitle: $('meta[property="og:title"]').attr("content"),
                CardDescription: $('meta[property="og:description"]').attr("content")
            },
            url: window.location.href,
            title: $('meta[property="og:title"]').attr("content"),
            description: $('meta[property="og:description"]').attr("content")
        };
    
        var ogImg = $('meta[property="og:image"]').attr("content");
        if (ogImg) {
            // Reduce the image size to fit for twitter.
            var regex = /\/\d+x\d+px\//i;
            window.addthis_share['media'] = ogImg.replace(regex, '/750x560px/');
        }

        //This code will make the goole map image and icons not appear on pinterest images by adding "nopin=nopin" attribute on each image in the explore the area map.
        window.SetNoPinForUnrellevantImage = function() {
            $('.explore-area-map').find('img').each(function () { $(this).attr("nopin", "nopin"); })
        }

        $("img[src*='shea-logo']").each(function () { $(this).attr("nopin", "nopin"); });
    }
});

